import React from 'react';
import { RouterProvider, Route } from 'atomic-router-react';
import { router } from 'src/models/routes/init';
import {
  homeRoute, projectsRoute, enHomeRoute, enProjectsRoute, notFoundRoute,
} from 'src/models/routes/index';
import { Home, Projects, NotFound } from './Pages';

const App = () => (
  <RouterProvider router={router}>
    <Route route={homeRoute} view={Home} />
    <Route route={enHomeRoute} view={Home} />
    <Route route={projectsRoute} view={Projects} />
    <Route route={enProjectsRoute} view={Projects} />
    <Route route={notFoundRoute} view={NotFound} />
  </RouterProvider>
);

export default App;
